import React from 'react';

const ExpertsPage = () => (
  <div>
    <h2>Experts</h2>
  </div>
);

export default ExpertsPage;
